export default __webpack_public_path__ + "static/media/PeggyMobley.4e9d2375.jpg";